import { Link } from "wouter";
import { Home } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-screen w-full flex items-center justify-center" style={{ background: "var(--background, #0a0f0a)" }}>
      <div className="flex flex-col items-center gap-6 text-center px-6">
        <div className="font-mono text-[72px] font-black leading-none" style={{ color: "rgba(74,222,128,0.18)" }}>
          404
        </div>
        <div className="space-y-2">
          <h1 className="text-xl font-semibold tracking-tight" style={{ color: "rgba(229,233,240,0.85)" }}>
            This page doesn't exist
          </h1>
          <p className="text-sm font-mono max-w-xs" style={{ color: "rgba(229,233,240,0.40)" }}>
            The URL you followed may be broken or the page may have been removed.
          </p>
        </div>
        <Link href="/">
          <button
            data-testid="link-home"
            className="flex items-center gap-2 px-4 py-2.5 rounded-lg text-sm font-mono transition-all border"
            style={{
              borderColor: "rgba(74,222,128,0.25)",
              background: "rgba(74,222,128,0.08)",
              color: "rgba(74,222,128,0.90)",
            }}
          >
            <Home className="w-4 h-4" />
            Back to home
          </button>
        </Link>
      </div>
    </div>
  );
}
